var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVP02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\t.upper2{fill:#d0e0f4;}\t.lower2{fill:#3f91ae;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "upper2",
    d: "M0,498.06l197.49,0.77c0.65-167.07,136.61-301.99,303.68-301.34c167.07,0.65,301.99,136.61,301.34,303.68      l197.49,0.76C1001.07,225.79,778.08,1.07,501.93,0C225.8-1.06,1.07,221.92,0,498.06z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "lower2",
    d: "M1000,501.94l-197.49-0.77c-0.65,167.07-136.61,301.99-303.68,301.34    c-167.07-0.65-301.99-136.61-301.34-303.68L0,498.06C-1.07,774.21,221.92,998.93,498.07,1000    C774.2,1001.07,998.93,778.08,1000,501.94z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVP02);
export default __webpack_public_path__ + "static/media/vP_02.7bc05dc893c4ffc01f122db51826bc5d.svg";
export { ForwardRef as ReactComponent };